import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Popover, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { intlShape } from 'react-intl'
import cx from 'classnames'
import { ShareButtons } from 'react-share'
import CopyToClipboard from 'react-copy-to-clipboard'
import GTMController from "../../utils/kpi/GTMController"
import {KPIController} from "../../utils/kpi/KPIController"

const { TwitterShareButton, FacebookShareButton } = ShareButtons

class ShareComponent extends PureComponent {
	constructor(props) {
		super(props)
		this.state = {
			isOpened: false,
			copiedURL: false,
		}

		this.tooltipClickToCopy = <Tooltip id="tooltipClickToCopy" />
		this.tooltipCopied = <Tooltip id="tooltipCopied" />
		this.onShareClick = this.onShareClick.bind(this)
	}

	componentDidMount() {
		const { intl } = this.context

		this.tooltipClickToCopy = (
			<Tooltip className="popover__feedback" id="tooltipClickToCopy" style={{ position: 'absolute' }}>
				{intl.formatMessage({ id: "share.popup.clickToCopy" })}
			</Tooltip>
		)
		this.tooltipCopied = (
			<Tooltip className="popover__feedback pct pct-checked" id="tooltipCopied" style={{ position: 'absolute' }}>
				{intl.formatMessage({ id: "share.popup.copied" })}
			</Tooltip>
		)
	}

	onEnter() {
		this.setState({isOpened: true})
	}

	onExited() {
		this.setState({isOpened: false})
	}

	closeOverlay() {
		this.overlayTrigger.hide()
	}

	onShareClick(shareEventSubType) {
		const { GTMCopyEvent } = this.props
		GTMController.pushShareEvent(GTMCopyEvent, shareEventSubType)
	}

	render() {
		const { share: { type, subject, body, url, twitter }, className, GTMCopyEvent } = this.props
		const { copied, isOpened } = this.state
		const { intl } = this.context

		const mail = {
			subject: type ? intl.formatMessage({ id: `share.mail.${type}.subject` }, subject) : '',
			body: type ? intl.formatMessage({ id: `share.mail.${type}.body` }, { ...body, url }) : ''
		}
		const shareTwitter = {
			title: type ? intl.formatMessage({ id: `share.twitter.${type}` }, twitter) : '',
			via: 'qobuz'
		}

		return (
			<OverlayTrigger
				placement="bottom"
				trigger="click"
				rootClose
				ref={(r) => this.overlayTrigger = r}
				onEnter={() => this.onEnter()}
				onExited={() => this.onExited()}
				overlay={
					<Popover id="popoverShare" className="popover" style={{ position: 'absolute' }}>
						<button className="popover__cross pct pct-cross" onClick={() => this.closeOverlay()} />
						<div className="popover__container" key="share-url">
							<p className="popover__text">{intl.formatMessage({ id: 'share.popup.link' })}</p>
							<CopyToClipboard
								text={url}
								onCopy={() => {
									if (GTMCopyEvent) {
										GTMController.pushShareEvent(GTMCopyEvent, undefined)
									}
									this._copyTrigger.hide()
									setTimeout(() => {
										this.setState({ copied: true })
									}, 200)
									setTimeout(() => {
										this._copyTrigger.show()
									}, 300)
								}}
							>
								<OverlayTrigger
									placement="top"
									ref={(ref) => { this._copyTrigger = ref }}
									overlay={copied ? this.tooltipCopied : this.tooltipClickToCopy}
								>
									<input
										type="text"
										ref="input"
										className="popover__link"
										value={url}
										onChange={() => {}}
										onFocus={() => { this.refs.input.select() }}
									/>
								</OverlayTrigger>
							</CopyToClipboard>
						</div>
						<div className="popover__social">
							<CopyToClipboard
								text={url}
							>
								<button className="popover__button pct pct-copy">{intl.formatMessage({ id: 'share.popup.copy' })}</button>
							</CopyToClipboard>
							<FacebookShareButton
								className="popover__button pct pct-facebook"
								url={url}
								beforeOnClick={() => {this.onShareClick(KPIController.EVENT_SUBTYPE.SHARE.FACEBOOK)} }
							/>
							<TwitterShareButton
								className="popover__button pct pct-twitter"
								url={url} {...shareTwitter}
								beforeOnClick={() => {this.onShareClick(KPIController.EVENT_SUBTYPE.SHARE.TWITTER)} }
							/>
							<a
								className="popover__button pct pct-email"
								href={`mailto:?subject=${encodeURIComponent(mail.subject)}&body=${encodeURIComponent(mail.body)}`}
								onClick={() => {
									this.onShareClick(KPIController.EVENT_SUBTYPE.SHARE.EMAIL)
								}}
							/>
						</div>
					</Popover>
				}
			>
				<span className={cx(className || 'heading__button pct pct-share', {'heading__button--active' : isOpened})}>
					{intl.formatMessage({ id: 'buttons.share' })}
				</span>
			</OverlayTrigger>
		)
	}
}

ShareComponent.contextTypes = {
	intl: intlShape
}

ShareComponent.propTypes = {
	share: PropTypes.shape({
		type: PropTypes.string,
		url: PropTypes.string
	}).isRequired,
	className: PropTypes.string,
	GTMCopyEvent: PropTypes.string
}

const mapStateToProps = state => ({
	share: state.share
})

export default connect(mapStateToProps)(ShareComponent)



// WEBPACK FOOTER //
// ./src/components/share/ShareComponent.js